<template>
  <div
    v-if="song"
    class="s_tooltip"
    :style="{transform: `translate(${x}px,${y}px)`}"
  >
    <span class="title">
      <b>{{ song.label }} </b> 
      <span v-if="song.year">({{ song.year }})</span>
      <small
        v-else
        class="has-text-grey is-size-7 has-text-weight-normal"
      >Unknown date</small> 
    </span>
    <span
      v-if="song.cover"
      class="subtitle"
    >Cover by {{ $store.state.artists[song.cover_artist_id].name }}</span>
    <div v-else>
      <span
        v-if="song.parent_id == ''"
        class="subtitle"
      >Original production</span>
      <span
        v-if="song.parent_id"
        class="subtitle"
      >Adaptation</span>
      <div
        v-if="authors.length > 0"
        class="artist"
      >
        <span class="icon is-small">
          <i class="mdi mdi-pencil" />
        </span>
        <span class="is-size-7">{{ showNameList(authors) }} </span>
      </div>
      <div
        v-if="composers.length > 0"
        class="artist"
      >
        <span class="icon is-small">
          <i class="mdi mdi-music" />
        </span>
        <span class="is-size-7">{{ showNameList(composers) }} </span>
      </div>
      <div
        v-if="interprets.length > 0"
        class="artist"
      >
        <span class="icon is-small">
          <i class="mdi mdi-microphone" />
        </span>
        <span class="is-size-7">{{ showNameList(interprets) }} </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	props: {
		artist: {
			required: true,
			type: Object
		},
		song: {
			required: true
		}
	},
	data () {
		return {
			x: 0,
			y: 0
		};
	},
	computed: {
		authors () {
			let ids = this.song.author_ids.filter(id => id != this.artist.id);
            
			if (this.artist != null && this.song.author_ids.filter(id => id == this.artist.id).length > 0) {
				ids.unshift(this.artist.id);
			}

			return ids.map(id => {
				return this.$store.state.artists[id]; 
			});
		},
		interprets () {
			let ids = this.song.interpret_ids.filter(id => id != this.artist.id);
            
			if (this.artist != null && this.song.interpret_ids.filter(id => id == this.artist.id).length > 0) {
				ids.unshift(this.artist.id);
			}

			return ids.map(id => {
				return this.$store.state.artists[id]; 
			});
		},
		composers () {
			let ids = this.song.composer_ids.filter(id => id != this.artist.id);
            
			if (this.artist != null && this.song.composer_ids.filter(id => id == this.artist.id).length > 0) {
				ids.unshift(this.artist.id);
			}

			return ids.map(id => {
				return this.$store.state.artists[id]; 
			});
		}
	},
	created () {
		window.addEventListener("mousemove", this.onMouseMove);
	},
	destroyed () {
		window.removeEventListener("mousemove", this.onMouseMove);
	},
	methods: {
		onMouseMove (payload) {
			this.x = payload.clientX;
			this.y = payload.clientY;
		},
		showNameList(artists) {
			let message = this.$truncate(artists[0].name);
			for (let i = 1; i < artists.length; i++) {
				if (i == artists.length - 1) {
					message += " et ";
				} else {
					message += ", ";
				}
				message += this.$truncate(artists[i].name);
			}
			return message;
		}
	}
};
</script>

<style lang="scss" scoped>
.s_tooltip {
    position: fixed;
    top: 5px;
    left: 5px;
    border-radius: 5px;
    padding: 0.75rem;
    padding-top: 0.5rem;
    box-shadow: 1px 1px 3px rgba(0,0,0,0.15);
    z-index: 2;
    background-color: rgba(255,255,255,0.9);

    .title {
      display: block;
      font-size: 0.9rem;
      margin-bottom: 0.2rem;
    }

    .subtitle {
      display: inline-block;
      font-size: 0.75rem;
      margin-bottom: 0;
      background-color: hsl(204, 10%, 89%);
      color: hsl(204, 10%, 30%);
      padding: 0.1rem 0.3rem;
      border-radius: 2px;
    }

    .icon {
        margin-right: 0.3rem;
    }

    .artist {
        font-size: 0.8rem;
    }
}
</style>
